import React from "react";
import { inject, observer } from "mobx-react";
import Logo from "./logo";
import UserMenu from "../common/userMenu";
import Language from "../language/language";
import { withRouter } from "react-router-dom";
import { $util } from "../../helper";

import "./stylesheets/header.scss";

@inject("languageStore", "commonStore")
@observer
@withRouter
export default class Header extends React.Component {
  changeLang = lang => {
    // 切换语言的时候，删除URL中的语言，赛事唯一ID、赛事类型ID
    // 获取url参数
    let paramsArr =
      window.location.search !== "" ? window.location.search.substr(1).split("&") : [];
    let replaceUrl = this.props.history.location.pathname;

    if (paramsArr.length > 0) {
      for (let i = 0; i < paramsArr.length; i++) {
        if (
          paramsArr[i].indexOf("locale") !== -1 ||
          paramsArr[i].indexOf("id") !== -1 ||
          paramsArr[i].indexOf("eventType") !== -1
        ) {
          //去掉locale、eventType和id字段
          paramsArr.splice(i, 1);
          i--;
        }
      }
    }

    if (paramsArr.length > 0) {
      replaceUrl = `${replaceUrl}?${paramsArr.join("&")}`;
    }

    this.props.history.push(replaceUrl);

    if (lang === this.props.languageStore.lang) {
      return;
    }
    this.props.commonStore.gTag("event", "switchLanguage", {
      pageName: $util.getPageName(),
      buttonName: lang
    });
    this.props.languageStore.changeLang(lang);
  };

  openRmWebSite = () => {
    this.props.commonStore.gTag("event", "officialSite", {
      pageName: $util.getPageName(),
      buttonName: "RoboMaster官网"
    });
  };

  openRmBBS = () => {
    this.props.commonStore.gTag("event", "bbsSite", {
      pageName: $util.getPageName(),
      buttonName: "RoboMaster论坛"
    });
  };

  render() {
    return (
      <div id="Header">
        <div className="container">
          <Logo></Logo>
          <div className="nav-right">
            <div className="nav-item">
              <a
                onClick={this.openRmWebSite}
                href={
                  process.env.LOGIN_DOMAIN +
                  (this.props.languageStore.lang === "en" ? "/en-US" : "/zh-CN")
                }
                className="nuxt-link-active"
              >
                <Language resource="WEBSITE" />
              </a>
            </div>
            <div className="nav-item">
              <a
                onClick={this.openRmBBS}
                href={process.env.REACT_APP_BBS_DOMAIN}
                className="nuxt-link-active"
              >
                <Language resource="BBS" />
              </a>
            </div>

            {this.props.languageStore.lang === "en" ? (
              <div className="change" onClick={this.changeLang.bind(this, "zh")}>
                <Language resource="CHANGE_CHINESE" />
              </div>
            ) : (
              <div className="change" onClick={this.changeLang.bind(this, "en")}>
                <Language resource="CHANGE_ENGLISH" />
              </div>
            )}
          </div>
        </div>
        <UserMenu />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/header/header.js